import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../../lib/utils.js';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, error, id, ...props }, ref) => {
    return (
      <div className="w-full">
        {label !== undefined && (
          <label htmlFor={id} className="mb-1.5 block text-xs font-medium text-slate-400">
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={id}
          className={cn(
            'flex h-9 w-full rounded-lg border bg-slate-800/50 px-3 py-2 text-sm text-slate-100 transition-colors',
            'placeholder:text-slate-500',
            'border-slate-700 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500',
            'disabled:cursor-not-allowed disabled:opacity-50',
            error !== undefined && 'border-red-500 focus:border-red-500 focus:ring-red-500',
            className,
          )}
          {...props}
        />
        {error !== undefined && <p className="mt-1 text-xs text-red-400">{error}</p>}
      </div>
    );
  },
);
Input.displayName = 'Input';
